module.exports = __webpack_public_path__ + "static/minimalist_workplace-18bd1cefeb2a9c64ce33b7f6dc4ee9d3.jpg";